<template>
    <!-- 会员注册页面 -->
    <div class="memberLogin">
        <!-- 会员注册头部 -->
        <div class="memberLogin-header">
            <div class="memberLogin-header-wrap">
                <div>欢迎访问河南省食品科学技术学会网站</div>
                <div>当前时间2022年9月1日 星期四</div>
                <div><span @click="goLogin">【会员登录】</span> <span @click="goRegister">【免费注册】</span></div>
            </div>
        </div>
        <!-- 会员注册logo -->
        <div class="memberLogin-logo">
            <div>
                <img src="../../assets/pc/Index/logo.png" alt="" />
            </div>
            <div>会员注册</div>
            <div>
                <div>
                    <img src="../../assets/pc/Mindex/phone.png" alt="" />
                </div>
                <div>
                    <div>0371-XXXXXXXX</div>
                    <div>如需帮助，请拨打电话</div>
                </div>
            </div>
        </div>
        <!-- 会员注册流程 -->
        <div class="memberLogin-flow">
            <div id="progress">
                <div class="bg-blue">
                    <img class="icon" src="../../assets/pc/academy/one.png"></img>
                    <span>请选择会员类型</span>
                </div>
                <div :class="flow>=1?'bg-blue':'bg-gray'">
                    <img class="icon" src="../../assets/pc/academy/two.png"></img>
                    <span>设置登录名称</span>
                    <div class="triangle-box">
                        <div class="triangle bg-blue" ></div>
                    </div>
                </div>
                <div :class="flow>=2?'bg-blue':'bg-gray'" >
                    <img class="icon" src="../../assets/pc/academy/three.png"></img>
                    <span>{{name}}</span>
                    <div class="triangle-box">
                        <div class="triangle" :class="flow>=1?'bg-blue':'bg-gray'"></div>
                    </div>
                </div>
                <div :class="flow>=3?'bg-blue':'bg-gray'" >
                    <img class="icon" src="../../assets/pc/academy/four.png"></img>
                    <span>注册成功</span>
                    <div class="triangle-box">
                        <div class="triangle" :class="flow>=2?'bg-blue':'bg-gray'"></div>
                    </div>
                </div>
                <div :class="flow>=4?'bg-blue':'bg-gray'">
                    <div class="triangle-box">
                        <div class="triangle" :class="flow>=3?'bg-blue':'bg-gray'"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 会员分类 -->
        <div class="memberLogin-classify-cont">
            <!-- 会员类型 -->
            <div class="memberLogin-classify-type" v-if="flow == 0">
                <div class="memberLogin-classify-left">
                    <div>
                        <img src="../../../src/assets/pc/Index/qy.png" alt="" />
                    </div>
                    <div>企业会员</div>
                    <div @click="goEnterprise">我要注册</div>
                </div>
                <div class="memberLogin-classify-right">
                    <div>
                        <img src="../../../src/assets/pc/Index/gr.png" alt="" />
                    </div>
                    <div>个人会员</div>
                    <div @click="goPersonage">我要注册</div>
                </div>
            </div>

            <!-- 登录名称 -->
            <div class="memberLogin-classify-name" v-if="flow == 1">
                <!-- 会员登陆姓名 -->
                <div class="memberLogin-name">
                    <label for=""><span>*</span>会员登录名:</label>
                    <input type="text" v-model="register.username" placeholder="请输入英文或数字" />
                </div>
                <!-- 登录密码 -->
                <div class="memberLogin-pass">
                    <label for=""><span>*</span>登录密码:</label>
                    <input type="text" v-model="register.password" placeholder="请输入登录密码" />
                </div>
                <!-- 确认密码 -->
                <div class="memberLogin-affirmName">
                    <label for=""><span>*</span>确认密码:</label>
                    <input type="text" v-model="register.repassword" placeholder="请输入确认密码" />
                </div>
                <!-- 电子邮箱 -->
                <div class="memberLogin-mail">
                    <label for=""><span>*</span>电子邮件:</label>
                    <input type="text" v-model="register.email" placeholder="请输入电子邮件" />
                </div>

                <div class="memberLogin-next" @click="nameNext">下一步</div>
            </div>

            <!-- 公司资料 -->
            <div class="memberLogin-classify-datum" v-if="(flow == 2&&type==2)">
                <!-- 您的姓名 -->
                <div class="memberLogin-name">
                    <label for=""><span>*</span>您的姓名:</label>
                    <input type="text" v-model="moldMeans.bossname" placeholder="请输入登录名" />
                </div>
                <!-- 公司职务 -->
                <div class="memberLogin-duties">
                    <label for=""><span>*</span>公司职务:</label>
                    <input type="text" v-model="moldMeans.jobname" placeholder="请输入公司职务" />
                </div>
                <!-- 公司名称 -->
                <div class="memberLogin-companyName">
                    <label for=""><span>*</span>公司名称:</label>
                    <input type="text" v-model="moldMeans.name" placeholder="请输入公司名称" />
                </div>
                <!-- 手机号 -->
                <div class="memberLogin-phone">
                    <label for=""><span>*</span>手机号:</label>
                    <input type="text" v-model="moldMeans.mobile" placeholder="请输入手机号" />
                </div>
                <!-- 企业类型 -->
                <div class="memberLogin-mold">
                    <label for=""><span>*</span>企业类型:</label>
                    <select @change="selectChange">
                        <option :value="itemw.id" :key="itemw.id" v-for="(itemw,indexw) in moldOptions">{{itemw.name}}</option>
                    </select>
                </div>
                <!-- 公司分类 -->
                <div class="memberLogin-mold">
                    <label for=""><span>*</span>公司分类:</label>
                    <select @change="cateChange">
                        <option :value="itemr.id" :key="itemr.id" v-for="(itemr,indexr) in cateOPtions" >{{itemr.name}}</option>
                    </select>
                </div>
                <!-- 企业地址 -->
                <div class="memberLogin-address">
                    <label for=""><span>*</span>企业地址:</label>
                    <input type="text" v-model="moldMeans.address" placeholder="请输入企业地址" />
                </div>
                <!-- 营业执照 -->
                <div class="memberLogin-license">
                    <label for=""><span>*</span>营业执照:</label>
                    <Upload @url="setnewUrl"></Upload>
                </div>

                

                <div class="memberLogin-next" @click="moldNext">下一步</div>
            </div>

            <!-- 个人资料 -->
            <div class="memberLogin-classify-zl" v-if="(flow == 2&&type==1)">
                <!-- 您的身份 -->
                <div class="memberLogin-identity">
                    <label for=""><span>*</span>您的身份:</label>
                    <select @change="identityChange">
                        <option :value="itemt.id" :key="itemt.id" v-for="(itemt,indext) in identityList" >{{itemt.name}}</option>
                    </select>
                </div>
                <!-- 您的姓名 -->
                <div class="memberLogin-name">
                    <label for=""><span>*</span>您的姓名:</label>
                    <input type="text" v-model="personage.name" placeholder="请输入您的姓名" />
                </div>
                <!-- 手机号码 -->
                <div class="memberLogin-phone">
                    <label for=""><span>*</span>手机号码:</label>
                    <input type="text" v-model="personage.mobile" placeholder="请输入确认密码" />
                </div>
                <!-- 技能方向 -->
                <div class="memberLogin-skill">
                    <label for=""><span>*</span>技能方向:</label>
                    <select @change="skillsChange">
                        <option :value="itemy.id" :key="itemy.id" v-for="itemy in skillsList" >{{itemy.name}}</option>
                    </select>
                </div>
                <!-- 个人介绍 -->
                <div class="memberLogin-introduce">
                    <label for=""><span>*</span>个人介绍:</label>
                    <textarea rows="5" v-model="personage.description" cols="20">请介绍一下你自己</textarea>
                </div>
                <!-- 资质证书 -->
                <div class="memberLogin-license">
                    <label for=""><span>*</span>资质证书:</label>
                    <Upload @url="setnewUrl"></Upload>
                </div>

                <div class="memberLogin-next" @click="perNext">下一步</div>
            </div>

            <!-- 注册成功 -->
            <div class="memberLogin-succeed" v-if="flow >=3">
                <div>
                    <img
                        src="../../../src/assets/pc/Index/succeed.png"
                        alt=""
                    />
                </div>
                <div>恭喜您，{{personage.name}}{{moldMeans.bossname}}注册成功！</div>
                <div class="memberLogin-next" @click="goIndex">下一步</div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from 'axios'
import Footer from "@/components/Footer.vue"; //底部
import Upload from "@/components/Upload.vue"; //上传
import { register,companytype,companycate,moldCompany,identity,skills,per, upload} from '../../network/data';
export default {
    // 组件名称
    name: "memberLogin",
    // 组件参数 接收来自父组件的数据
    props: {},
    // 组件状态值
    data() {
        return {
            // 0==会员类型，1==企业登录名称，2==企业公司资料，2==个人资料，3==企业注册成功
            flow:0,
            // 判别是个人注册还是企业注册,2==企业,1==个人
            type:"",
            // 上传
            dialogImageUrl: "",
            dialogVisible: false,
            // 设置登录名称成功后返回的user_id
            user_id:"",
            // 设置登录名称
            register:{
                username:"",
                password:"",
                repassword:"",
                email:""
            },
            // 填写公司资料
            moldMeans:{
                bossname:"",
                jobname:"",
                name:"",
                mobile:"",
                address:""
            },
            // 填写个人资料
            personage:{
                name:"",
                mobile:"",
                description:""
            },
            // 公司类型数据
            moldOptions: [],
            // 选中公司类型id
            moldId:"",
            // 公司分类数据
            cateOPtions:[],
            // 选中公司分类
            cateId:"",
            // 本地上传的图片
            file:null,
            // 文件流
            formData:{},
            // 上传后的图片
            img:'',
            // 个人会员身份列表
            identityList:[],
            // 选中的身份
            identityId:"",
            // 个人技能方向列表
            skillsList:[],
            // 选中的技能
            skillsId:""
        };
    },
    // 计算属性
    computed: {
        // 判断显示填写公司资料还是填写个人资料
        name(){
            return this.type=="2"?'填写公司资料':'填写个人资料'
        }
    },
    // 侦听器
    watch: {},
    // 组件方法
    created() {
        // 获取公司类型
        this.companytypeRe()
        // 获取个人身份列表
        this.identityRe()
        // 获取技能方向列表
        this.skillsRe()
    },
    methods: {
        // 获取公司类型
        companytypeRe(){
            companytype().then((res) => {
                if (res.code == 1) {
                //    console.log(res.data);
                   this.moldOptions=res.data
                   this.moldOptions.unshift({id:0,name:"请选择"})
                } else {
                   this.message(res.msg);
                }
            });
        },
        // 获取公司分类
        companycateRe() {
            let data={
                typeid:this.moldId,
            }
            companycate(data).then((res) => {
               if (res.code == 1) {
                //   console.log(res.data);
                  this.cateOPtions=res.data
               } else {
                  this.message(res.msg);
               }
           });
        },
        // 获取个人会员身份列表
        identityRe(){
            identity().then((res) => {
                if (res.code == 1) {
                //    console.log(res.data);
                   this.identityList=res.data
                   this.identityList.unshift({id:0,name:"请选择"})
                } else {
                   this.message(res.msg);
                }
            });
        },
        // 获取技能方向列表
        skillsRe() {
            skills().then((res) => {
               if (res.code == 1) {
                //   console.log(res.data);
                  this.skillsList=res.data
                  this.skillsList.unshift({id:0,name:"请选择"})
               } else {
                  this.message(res.msg);
               }
           });
        },
        // 删除触发事件
        handleRemove(file, fileList) {
            console.log(file, fileList,'删除结果');
        },
        // 上传成功触发事件
        handlSuccess(response, file, fileList){
            console.log(response, file, fileList,'上传成功')
        },
        // 设置登录名称下一步
        nameNext() {
            if (this.register.username == "") {
                this.$message.warning({
                    message: "用户名为空",
                    duration: 1000,
                    customClass: "myBox",
                });
                return;
            }else if(this.register.password==""){
                this.$message.warning({
                    message: "密码为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.register.repassword==""){
                this.$message.warning({
                    message: "确认密码为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.register.email==""){
                this.$message.warning({
                    message: "邮箱为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else{
                // this.flow++
                let data={
                    type:this.type,
                    username:this.register.username,//用户名
                    password:this.register.password,//密码
                    repassword:this.register.repassword,//确认密码
                    email:this.register.email
                }
                register(data).then((res) => {
                    if (res.code == 1) {
                        this.flow ++;
                        this.user_id=res.data.user_id
                    } else {
                        this.$message.warning({
                            message:res.msg,
                            duration: 1000,
                            customClass: "myBox",
                        });
                    }
                });
            }

            
        },
        // 填写公司资料下一步
        moldNext(){
            if (this.moldMeans.bossname == "") {
                this.$message.warning({
                    message: "姓名为空",
                    duration: 1000,
                    customClass: "myBox",
                });
                return;
            }else if(this.moldMeans.jobname==""){
                this.$message.warning({
                    message: "公司职务为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.moldMeans.name==""){
                this.$message.warning({
                    message: "公司名称为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.moldMeans.mobile==""){
                this.$message.warning({
                    message: "手机号为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.moldId==""){
                this.$message.warning({
                    message: "企业类型为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            } else if(this.cateId==""){
                this.$message.warning({
                    message: "公司分类为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.moldMeans.address==""){
                this.$message.warning({
                    message: "企业地址为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.img==""){
                this.$message.warning({
                    message: "请点击上传",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else{
                let data={
                    user_id:this.user_id,
                    bossname:this.moldMeans.bossname,
                    jobname:this.moldMeans.jobname,
                    name:this.moldMeans.name,
                    mobile:this.moldMeans.mobile,
                    type_id:this.moldId,
                    cate_id:this.cateId,
                    licenseimage:this.img,
                    address:this.moldMeans.address
                }
                moldCompany(data).then((res) => {
                    if (res.code == 1) {
                        this.flow ++;
                    } else {
                        this.$message.warning({
                            message:res.msg,
                            duration: 1000,
                            customClass: "myBox",
                        });
                    }
                });
            }
            
        },
        // 填写个人资料
        perNext(){
            if (this.identityId == "") {
                this.$message.warning({
                    message: "身份为空",
                    duration: 1000,
                    customClass: "myBox",
                });
                return;
            }else if(this.personage.name==""){
                this.$message.warning({
                    message: "姓名为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.personage.mobile==""){
                this.$message.warning({
                    message: "手机号为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.skillsId==""){
                this.$message.warning({
                    message: "技能方向为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.personage.description==""){
                this.$message.warning({
                    message: "个人介绍为空",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else if(this.img==""){
                this.$message.warning({
                    message: "请点击上传",
                    duration: 1000,
                    customClass: "myBox",
                });
            }else{
                let data={
                    user_id:this.user_id,
                    identity_id:this.identityId,//身份
                    skill_ids:this.skillsId,//技能方向
                    name:this.personage.name,//姓名
                    mobile:this.personage.mobile,//手机号
                    images:this.img,//资质证书
                    description:this.personage.description//个人介绍
                }
                per(data).then((res) => {
                    if (res.code == 1) {
                        this.flow ++;
                    } else {
                        this.$message.warning({
                            message:res.msg,
                            duration: 1000,
                            customClass: "myBox",
                        });
                    }
                });
            }
            
        },
        goIndex(){
            this.$router.push({
                path: "/index",
            });
        },
        // 上传营业执照返回结果
        // changeFile(e){
        //     this.file=e.target.files[0];
        //     let formData=new FormData()
        //     // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
        //     formData.append('file',this.file)
        //     // this.uploadRe()
        //     // console.log(formData);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。
        //     axios.post('http://admin.shipin.dd371.com/api/common/upload',formData).then(res=>{
        //         this.img=res.data.data.url
        //     })
        // },
        // 图片转化为base64
        // handleRemoves() {
        //     var reader = new FileReader();
        //     reader.readAsDataURL(this.file);
        //     reader.onload = () => {
        //         // console.log("file 转 base64结果：" + reader.result);
        //         this.base64file='data:image/png;base64,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'
        //         this.uploadRe()
        //     };
        //     reader.onerror = function(error) {
        //         console.log("Error: ", error);
        //     };
        // },
        setnewUrl(e) {
            console.log(e);
            
            this.img = e;
        },

        // 企业会员
        goEnterprise() {
            this.type=2;
            this.flow = 1;
        },
        // 个人会员
        goPersonage() {
            this.type=1
            this.flow = 1;
        },
        // 公司类型选择
        selectChange(e) {
            // console.log('123456897')
            this.moldId=e.target.value
            // 获取公司分类数据
            this.companycateRe()
        },
        // 公司分类选择
        cateChange(e){
            this.cateId=e.target.value
        },
        // 选择的身份
        identityChange(e){
            this.identityId=e.target.value
        },
        // 选中的身份
        skillsChange(e){
            this.skillsId=e.target.value
        },
        // 跳转到登录
        goLogin() {
            this.$router.push("/login");
        },
        // 跳转到注册
        goRegister() {
            this.$router.push("/memberRegister");
        },
    },
    mounted() {},
    // 局部注册的组件
    components: {
        Footer,
        Upload
    },
};
</script>

<style lang="scss">
// 修改message弹框样式
// .myBox {
//     min-width: 130px !important;
//     height: 25px !important;
//     padding: 3px !important;
//     text-align: center !important;
//     display: flex !important;
//     justify-content: center !important;
//     .el-message__icon {
//         font-size: 10px;
//     }
//     .el-message__content {
//         font-size: 8px;
//     }
// }


// .memberLogin {
//     // 会员注册头部
//     .memberLogin-header {
//         width: 100%;
//         height: 20px;
//         line-height: 20px;
//         background-color: #f6f6f6;

//         .memberLogin-header-wrap {
//             display: flex;
//             width: 70%;
//             margin: 0 auto;
//             font-size: 8px;
//             color: #666666;

//             > div:nth-child(1) {
//                 margin-right: 30px;
//             }

//             > div:nth-child(3) {
//                 margin-left: auto;
//                 cursor: pointer;
//             }
//         }
//     }

//     // 会员注册logo
//     .memberLogin-logo {
//         display: flex;
//         width: 70%;
//         height: 55px;
//         line-height: 75px;
//         margin: 0 auto;
//         padding: 10px 0;
//         font-size: 15px;
//         box-sizing: border-box;
//         // border: 1px solid red;

//         > div:nth-child(1) {
//             // overflow: hidden;
//             width: 35%;
//             height: 100%;
//             padding: 1px 0;
//             padding-right: 10px;
//             // margin-right: 10px;
//             box-sizing: border-box;
//             border-right: 1px solid #eeeeee;

//             img {
//                 display: block;
//                 width: 100%;
//                 height: 100%;
//                 // border: 1px solid red;
//             }
//         }

//         > div:nth-child(2) {
//             display: flex;
//             align-items: center;
//             margin-left: 10px;
//             // border: 1px solid red;
//         }

//         > div:nth-child(3) {
//             display: flex;
//             align-items: center;
//             justify-content:flex-end;
//             width: 40%;
//             margin-left: auto;
//             font-size: 10px;
//             // border: 1px solid red;
            
//             > div:nth-child(1) {
//                 display: flex;
//                 width: 17px;
//                 height: 17px;
//                 margin-top: 2px;
//                 margin-right: 5px;
//                 // border: 1px solid red;

//                 >img{
//                     width: 100%;
//                     height:100%;
//                 }
//             }

//             > div:nth-child(2) {
//                 display: flex;
//                 flex-direction: column;
//                 line-height: 10px;
//                 margin-left:10px;

//                 > div:nth-child(1) {
//                     margin-bottom: 3px;
//                     color: #333333;
//                 }

//                 > div:nth-child(2) {
//                     font-size: 8px;
//                     color: #999999;
//                 }
//             }
//         }
//     }
//     // 会员注册流程
//     .memberLogin-flow {
//         width: 100%;
//         display: flex;
//         height: 20px;
//         background-color: #fff;

//         #progress {
//             width: 100%;
//             display: flex;
//             justify-content: start;

//             > div {
//                 cursor: pointer;
//                 width: 30%;
//                 height: 100%;
//                 font-size: 8px;
//                 line-height: 20px;
//                 color: white;
//                 position: relative;
//                 text-align: center;

//                 .icon{
//                     overflow: hidden;
//                     width:10px;
//                     height:10px;
//                     margin-bottom:-2px;
//                     margin-right:5px;
//                     box-sizing: border-box;
//                 }

//                 /* 三角形 */
//                 .triangle-box {
//                     display: inline-block;
//                     width: 20px;
//                     height: 34px;
//                     overflow: hidden;
//                     position: absolute;
//                     left: 0;
//                     // border:1px solid red;
//                 }
//                 .triangle {
//                     transform: rotate(45deg);
//                     transform-origin: left top;
//                     position: absolute;
//                     top: -2px;
//                     left: -1.5px;
//                     width: 15px;
//                     height: 13px;
//                     border: 2px solid white;
//                 }
//             }

//             > div:nth-child(1) {
//                 width: 40%;
//                 padding-left: 9%;
//             }

//             > div:last-child {
//                 width: 40%;
//             }
//         }

//         /* 红色、灰色背景 */
//         .bg-blue {
//             background-color: #0056b0;
//         }
//         .bg-gray {
//             background-color: #cccccc;
//         }
//     }

//     // 会员分类
//     .memberLogin-classify-cont {
//         font-size: 15px;
//         border:1px solid #f6f6f6;
//         background-color: #f6f6f6;

//         // 会员类型 start
//         .memberLogin-classify-type {
//             display: flex;
//             justify-content: center;
//             width: 70%;
//             margin: 100px auto;
//             // border: 1px solid red;

//             .memberLogin-classify-left {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 margin-right: 20px;
//                 padding-right: 40px;
//                 padding-bottom: 20px;
//                 border-right: 1px solid #f6f6f6;

//                 > div:nth-child(1) {
//                     margin: 0 auto;
//                     width: 100%;
//                     height: 60px;
//                     // border: 1px solid red;

//                     > img {
//                         width: 100%;
//                         height: 100%;
//                     }
//                 }

//                 > div:nth-child(2) {
//                     margin-top: 20px;
//                     font-size: 11px;
//                     color: #333333;
//                 }
//                 > div:nth-child(3) {
//                     margin-top: 10px;
//                     padding: 3px 0;
//                     font-size: 10px;
//                     color: #fff;
//                     background-color: #88b8ea;
//                 }
//             }
//             .memberLogin-classify-right {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 margin-left: 20px;
//                 // border: 1px solid red;
//                 > div:nth-child(1) {
//                     margin: 0 auto;
//                     width: 100%;
//                     height: 60px;
//                     // border: 1px solid red;

//                     > img {
//                         width: 100%;
//                         height: 100%;
//                     }
//                 }

//                 > div:nth-child(2) {
//                     margin-top: 20px;
//                     font-size: 11px;
//                     color: #333333;
//                 }
//                 > div:nth-child(3) {
//                     margin-top: 10px;
//                     padding: 3px 0;
//                     font-size: 10px;
//                     color: #fff;
//                     background-color: #4bbf8e;
//                 }
//             }
//         }
//         // 会员类型 end

//         // 登录名称 start
//         .memberLogin-classify-name {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             width: 70%;
//             padding: 30px 0;
//             margin: 10px auto;
//             background-color:#fff;
//             // border: 1px solid red;

//             .memberLogin-name,
//             .memberLogin-pass,
//             .memberLogin-affirmName,
//             .memberLogin-mail {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 23%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }

//                 > input {
//                     width: 73%;
//                     height: 15px;
//                 }
//             }

//             .memberLogin-next {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 padding: 2px 0;
//                 margin: 0 auto;
//                 color: #fff;
//                 font-size: 11px;
//                 background-color: #0056b0;
//             }
//         }
//         // 登录名称 end

//         // 公司资料 start
//         .memberLogin-classify-datum {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             width: 70%;
//             padding: 30px 0;
//             margin: 10px auto;
//             background-color: #fff;

//             .memberLogin-name,
//             .memberLogin-duties,
//             .memberLogin-companyName,
//             .memberLogin-phone,
//             .memberLogin-mold,
//             .memberLogin-address {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }

//                 > input {
//                     width: 80%;
//                     height: 15px;
//                 }
//             }

//             .memberLogin-license {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }
//                 .el-upload {
//                     width: 80px !important;
//                     height: 80px !important;
//                     line-height: 80px !important;
//                 }

//                 .el-icon-plus {
//                     font-size: 20px !important;
//                 }
//             }

//             .memberLogin-next {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 padding: 2px 0;
//                 margin: 0 auto;
//                 color: #fff;
//                 font-size: 11px;
//                 background-color: #0056b0;
//             }
//         }
//         // 公司资料 end

//         // 个人资料 start
//         .memberLogin-classify-zl {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             width: 70%;
//             padding: 30px 0;
//             margin: 10px auto;
//             background-color: #fff;
//             // border: 1px solid red;

//             .memberLogin-identity,
//             .memberLogin-skill {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }

//                 > select {
//                     width: 80%;
//                     height: 15px;
//                 }
//             }

//             .memberLogin-name,
//             .memberLogin-phone {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }

//                 > input {
//                     width: 80%;
//                     height: 15px;
//                 }
//             }

//             .memberLogin-introduce {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }

//                 > textarea {
//                     width: 80%;
//                     height: 100px;
//                 }
//             }

//             .memberLogin-license {
//                 display: flex;
//                 width: 60%;
//                 margin-top: 10px;
//                 margin: 0 auto;
//                 margin-bottom: 10px;
//                 font-size: 10px;

//                 > label {
//                     display: block;
//                     width: 20%;
//                     text-align: end;
//                     box-sizing: border-box;
//                     padding-right: 10px;
//                     // border: 1px solid red;
//                 }
//                 .el-upload {
//                     width: 80px !important;
//                     height: 80px !important;
//                     line-height: 80px !important;
//                 }

//                 .el-icon-plus {
//                     font-size: 20px !important;
//                 }
//             }

//             .memberLogin-next {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 padding: 2px 0;
//                 margin: 0 auto;
//                 color: #fff;
//                 font-size: 11px;
//                 background-color: #0056b0;
//             }
//         }
//         // 个人资料 end

//         // 注册成功 start
//         .memberLogin-succeed {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             width: 70%;
//             padding: 100px 0;
//             margin: 10px auto;
//             background-color: #fff;
//             // border: 1px solid red;

//             > div:nth-child(1) {
//                 width: 50px;
//                 height: 50px;
//                 margin: 0 auto;

//                 img {
//                     width: 100%;
//                     height: 100%;
//                 }
//             }

//             > div:nth-child(2) {
//                 margin: 10px auto;
//                 font-size: 12px;
//             }

//             .memberLogin-next {
//                 cursor: pointer;
//                 text-align: center;
//                 width: 60px;
//                 padding: 2px 0;
//                 margin: 0 auto;
//                 color: #fff;
//                 font-size: 11px;
//                 background-color: #0056b0;
//             }
//         }
//         // 注册成功 end
//     }
// }

// //当屏幕最小宽度为992px
// @media screen and (min-width: 1200px) {
// }

// //当屏幕宽度 最小为768px 最大为991px时
// @media screen and (min-width: 768px) and (max-width: 1200px) {
//     .memberLogin {
//         // 会员注册头部
//         .memberLogin-header {
//             width: 100%;
//             height: 20px;
//             line-height: 20px;
//             background-color: #f6f6f6;

//             .memberLogin-header-wrap {
//                 display: flex;
//                 width: 70%;
//                 margin: 0 auto;
//                 font-size: 6px;
//                 color: #666666;

//                 > div:nth-child(1) {
//                     margin-right: 30px;
//                 }

//                 > div:nth-child(3) {
//                     margin-left: auto;
//                 }
//             }
//         }

//         // 会员注册logo
//         .memberLogin-logo {
//             display: flex;
//             width: 70%;
//             height: 55px;
//             line-height: 75px;
//             margin: 0 auto;
//             padding: 10px 0;
//             font-size: 15px;
//             box-sizing: border-box;
//             // border: 1px solid red;

//             > div:nth-child(1) {
//                 // overflow: hidden;
//                 width: 38%;
//                 height: 100%;
//                 padding: 1px 0;
//                 padding-right: 10px;
//                 // margin-right: 10px;
//                 box-sizing: border-box;
//                 border-right: 1px solid #eeeeee;

//                 img {
//                     display: block;
//                     width: 100%;
//                     height: 100%;
//                     // border: 1px solid red;
//                 }
//             }

//             > div:nth-child(2) {
//                 display: flex;
//                 align-items: center;
//                 margin-left: 10px;
//                 // border: 1px solid red;
//             }

//             > div:nth-child(3) {
//                 display: flex;
//                 align-items: center;
//                 justify-content: end;
//                 width: 40%;
//                 margin-left: auto;
//                 font-size: 10px;
//                 // border: 1px solid red;
//                 > div:nth-child(1) {
//                     display: flex;
//                     width: 17px;
//                     height: 17px;
//                     margin-top: 2px;
//                     margin-right: 5px;
//                     // border: 1px solid red;
//                 }

//                 > div:nth-child(2) {
//                     display: flex;
//                     flex-direction: column;
//                     line-height: 10px;

//                     > div:nth-child(1) {
//                         margin-bottom: 3px;
//                         color: #333333;
//                     }

//                     > div:nth-child(2) {
//                         font-size: 8px;
//                         color: #999999;
//                     }
//                 }
//             }
//         }
//         // 会员注册流程
//         .memberLogin-flow {
//             display: flex;
//             height: 20px;
//             background-color: #979797;

//             #progress {
//                 width: 100%;
//                 display: flex;
//                 justify-content: start;

//                 > div {
//                     cursor: pointer;
//                     width: 30%;
//                     height: 100%;
//                     font-size: 6px;
//                     line-height: 20px;
//                     color: white;
//                     position: relative;
//                     text-align: center;

//                     .icon{
//                         overflow: hidden;
//                         width:10px;
//                         height:10px;
//                         margin-bottom:-3px;
//                         margin-right:5px;
//                         box-sizing: border-box;
//                     }

//                     /* 三角形 */
//                     .triangle-box {
//                         display: inline-block;
//                         width: 20px;
//                         height: 34px;
//                         overflow: hidden;
//                         position: absolute;
//                         left: 0;
//                         // border:1px solid red;
//                     }
//                     .triangle {
//                         transform: rotate(45deg);
//                         transform-origin: left top;
//                         position: absolute;
//                         top: -2px;
//                         left: -1.5px;
//                         width: 15px;
//                         height: 13px;
//                         border: 2px solid white;
//                     }
//                 }

//                 > div:nth-child(1) {
//                     width: 50%;
//                     padding-left: 9%;
//                 }

//                 > div:last-child {
//                     width: 40%;
//                 }
//             }

//             /* 红色、灰色背景 */
//             .bg-blue {
//                 background-color: #0056b0;
//             }
//             .bg-gray {
//                 background-color: #cccccc;
//             }
//         }

//         // 会员分类
//         .memberLogin-classify-cont {
//             font-size: 15px;
//             margin-bottom: 43vh;
//             // border: 1px solid red;

//             // 会员类型 start
//             .memberLogin-classify-type {
//                 display: flex;
//                 justify-content: center;
//                 width: 70%;
//                 margin: 100px auto;
//                 // border: 1px solid #979797;

//                 .memberLogin-classify-left {
//                     cursor: pointer;
//                     text-align: center;
//                     width: 60px;
//                     margin-right: 20px;
//                     padding-right: 40px;
//                     padding-bottom: 20px;
//                     border-right: 1px solid #f6f6f6;

//                     > div:nth-child(1) {
//                         margin: 0 auto;
//                         width: 100%;
//                         height: 60px;
//                         // border: 1px solid red;

//                         > img {
//                             width: 100%;
//                             height: 100%;
//                         }
//                     }

//                     > div:nth-child(2) {
//                         margin-top: 20px;
//                         font-size: 11px;
//                         color: #333333;
//                     }
//                     > div:nth-child(3) {
//                         margin-top: 10px;
//                         padding: 3px 0;
//                         font-size: 10px;
//                         color: #fff;
//                         background-color: #88b8ea;
//                     }
//                 }
//                 .memberLogin-classify-right {
//                     cursor: pointer;
//                     text-align: center;
//                     width: 60px;
//                     margin-left: 20px;
//                     // border: 1px solid red;
//                     > div:nth-child(1) {
//                         margin: 0 auto;
//                         width: 100%;
//                         height: 60px;
//                         // border: 1px solid red;

//                         > img {
//                             width: 100%;
//                             height: 100%;
//                         }
//                     }

//                     > div:nth-child(2) {
//                         margin-top: 20px;
//                         font-size: 11px;
//                         color: #333333;
//                     }
//                     > div:nth-child(3) {
//                         margin-top: 10px;
//                         padding: 3px 0;
//                         font-size: 10px;
//                         color: #fff;
//                         background-color: #4bbf8e;
//                     }
//                 }
//             }
//             // 会员类型 end

//             // 登录名称 start
//             .memberLogin-classify-name {
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 width: 70%;
//                 padding: 30px 0;
//                 margin: 10px auto;
//                 border: 1px solid #979797;
//                 background-color: #fff;

//                 .memberLogin-name,
//                 .memberLogin-pass,
//                 .memberLogin-affirmName,
//                 .memberLogin-mail {
//                     display: flex;
//                     width: 65%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 8px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }

//                     > input {
//                         width: 70;
//                         height: 10px;
//                     }
//                 }

//                 .memberLogin-next {
//                     cursor: pointer;
//                     text-align: center;
//                     width: 60px;
//                     padding: 2px 0;
//                     margin: 0 auto;
//                     color: #fff;
//                     font-size: 11px;
//                     background-color: #0056b0;
//                 }
//             }
//             // 登录名称 end

//             // 公司资料 start
//             .memberLogin-classify-datum {
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 width: 70%;
//                 padding: 30px 0;
//                 margin: 10px auto;
//                 border: 1px solid #979797;

//                 select {
//                     width: 70%;
//                     height: 15px;
//                     border: 1px solid #979797;
//                 }

//                 .memberLogin-name,
//                 .memberLogin-duties,
//                 .memberLogin-companyName,
//                 .memberLogin-phone,
//                 .memberLogin-mold,
//                 .memberLogin-address {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }

//                     > input {
//                         width: 70%;
//                         height: 15px;
//                         border: 1px solid #979797;
//                     }
//                 }

//                 .memberLogin-license {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 20%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }
                    
//                     .el-upload {
//                         width: 80px !important;
//                         height: 80px !important;
//                         line-height: 80px !important;
//                     }

//                     .el-icon-plus {
//                         font-size: 20px !important;
//                     }
//                 }

//                 .memberLogin-next {
//                     cursor: pointer;
//                     text-align: center;
//                     width: 60px;
//                     padding: 2px 0;
//                     margin: 0 auto;
//                     color: #fff;
//                     font-size: 11px;
//                     background-color: #0056b0;
//                 }
//             }
//             // 公司资料 end

//             // 个人资料 start
//             .memberLogin-classify-zl {
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 width: 70%;
//                 padding: 30px 0;
//                 margin: 10px auto;
//                 border: 1px solid #979797;

//                 .memberLogin-identity,
//                 .memberLogin-skill {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }

//                     > select {
//                         width: 70%;
//                         height: 15px;
//                         border: 1px solid #979797;
//                     }
//                 }

//                 .memberLogin-name,
//                 .memberLogin-phone {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }

//                     > input {
//                         width: 70%;
//                         height: 15px;
//                         border: 1px solid #979797;
//                     }
//                 }

//                 .memberLogin-introduce {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }

//                     > textarea {
//                         width: 70%;
//                         height: 100px;
//                         border: 1px solid #979797;
//                     }
//                 }

//                 .memberLogin-license {
//                     display: flex;
//                     width: 60%;
//                     margin-top: 10px;
//                     margin: 0 auto;
//                     margin-bottom: 10px;
//                     font-size: 10px;

//                     > label {
//                         display: block;
//                         width: 30%;
//                         text-align: end;
//                         box-sizing: border-box;
//                         padding-right: 10px;
//                         // border: 1px solid red;
//                     }
//                     .el-upload {
//                         width: 80px !important;
//                         height: 80px !important;
//                         line-height: 80px !important;
//                     }

//                     .el-icon-plus {
//                         font-size: 20px !important;
//                     }
//                 }

//                 .memberLogin-next {
//                     cursor: pointer;
//                     text-align: center;
//                     width: 60px;
//                     padding: 2px 0;
//                     margin: 0 auto;
//                     color: #fff;
//                     font-size: 11px;
//                     background-color: #0056b0;
//                 }
//             }
//             // 个人资料 end

//             // 注册成功 start
//             .memberLogin-succeed {
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 width: 70%;
//                 padding: 100px 0;
//                 margin: 10px auto;
//                 background-color: #fff;
//                 // border: 1px solid #979797;

//                 > div:nth-child(1) {
//                     width: 50px;
//                     height: 50px;
//                     margin: 0 auto;

//                     img {
//                         width: 100%;
//                         height: 100%;
//                     }
//                 }

//                 > div:nth-child(2) {
//                     margin: 10px auto;
//                     font-size: 12px;
//                 }
//             }
//             // 注册成功 end
//         }
//     }
// }

// //当屏幕最大宽度为767px
// @media screen and (max-width: 767px) {
// }
</style>
